import { render, staticRenderFns } from "./AssessmentFarmerResponses.vue?vue&type=template&id=2b34b3fe&scoped=true"
import script from "./AssessmentFarmerResponses.vue?vue&type=script&lang=js"
export * from "./AssessmentFarmerResponses.vue?vue&type=script&lang=js"
import style0 from "./AssessmentFarmerResponses.vue?vue&type=style&index=0&id=2b34b3fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b34b3fe",
  null
  
)

export default component.exports